/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({ ...props }) => (
  <>
    <div className="modal-body">{props.children}</div>
  </>
);

ModalBody.propTypes = {
  children: PropTypes.any,
};

export default ModalBody;
